import { getDomain } from 'tldts';
import {
  S3_BUCKET_BASE_URL,
  DEFAULT_PROFILE_IMAGE_CHANNELS,
} from '../../constants';

export const getImageUrl = (
  img,
  defaultImage = DEFAULT_PROFILE_IMAGE_CHANNELS,
) => {
  if (!img) return defaultImage;

  if (!img.includes || !img.includes('http'))
    return `${S3_BUCKET_BASE_URL}/${img}`;

  return img;
};

export function getRootDomain(hostname) {
  if (hostname === 'localhost') return hostname;

  return getDomain(hostname) ?? hostname;
}
